import template from './help.html';

/**
 * View Model
 */
class HelpDialogViewModel {
	/**
	 * ViewModel constructor.
	 * @param {HelpDialogClass} dialog - SampleDialog class
	 */
	constructor(dialog) {
		let self = this;
		this.dialog = dialog;

		this.help_info = ko.observable();
	};
	close_click() {
		this.dialog.close(true);
	}
}

class HelpDialogClass {
	/**
	 * constructor
	 * @param {Object} bindings -
	 */
	constructor(bindings, element) {
		let self = this;
		this.self = self;
		this.bindings = bindings;
		this.element = element;

		this.viewModel = new HelpDialogViewModel(this); // Name of the ViewModel defined above
	}

	async init() {
		switch (typeof this.bindings)
		{
			case 'string':
				// If the provided string contains a '/' and no '<', '>', '=' or '"', I'll assume the parameter refers to a path
				if (this.bindings.includes('/') && !(/[<>="]/.test(this.bindings)))
				{
					let response = await window.Grape.fetches.fetch(this.bindings);
					this.viewModel.help_info(await response.text());
				}
				else
				{
					this.viewModel.help_info(this.bindings);
				}
		}
		let init_promise = new Promise((resolve, reject) => { resolve() });
		return init_promise;
	};
}

export default {
	name: 'HelpDialog',
	dialog_class: HelpDialogClass,
	template: template,
	provider: "ps"
};